import React from 'react';

export default function Privacypolicy() {
  const sections = [
    {
      num: "01",
      eyebrow: "Overview",
      title: "Introduction",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">
              This Privacy Policy sets out how <strong>VESHH-EON</strong> ("we", "us", "our") collects, uses, stores, and protects any personal information you provide when you visit <strong>veshheon.in</strong> or purchase from us.
            </p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">
              We are committed to ensuring your privacy is protected at all times. Any information we collect will only be used in accordance with this Privacy Policy and applicable Indian law, including the <strong>Digital Personal Data Protection Act, 2023 (DPDP Act)</strong> and the Information Technology Act, 2000.
            </p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">
              We may update this policy from time to time. We encourage you to review this page periodically to stay informed of any changes. Continued use of our website after changes are posted constitutes your acceptance of the revised policy.
            </p>
          </div>
        </div>
      ),
    },
    {
      num: "02",
      eyebrow: "Collection",
      title: "Information We Collect",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Name</strong> — used for order processing, personalization, and customer support.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Email Address</strong> — used to send order confirmations, shipping updates, and occasional product communications.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Mobile Number</strong> — used for order-related communication and customer support.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Delivery Address</strong> — used solely to fulfil and ship your order to the correct location.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Payment Information</strong> — we do not store your full card details. All payment transactions are processed through our secure third-party payment gateway partners.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Usage Data</strong> — we may collect anonymized information about how you interact with our website (pages visited, time spent, device type) through cookies and analytics tools to improve our services.</p>
          </div>
        </div>
      ),
    },
    {
      num: "03",
      eyebrow: "Usage",
      title: "How We Use Your Information",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">To process and fulfil your orders, including dispatch, tracking, and delivery coordination.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">To send transactional communications — order confirmations, shipping notifications, and return/refund updates.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">To send promotional communications about new drops, offers, or events — only with your prior consent. You may opt out at any time.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">For internal record keeping, fraud prevention, and legal compliance.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">To improve our website, product range, and customer experience based on aggregated and anonymized usage data.</p>
          </div>
        </div>
      ),
    },
    {
      num: "04",
      eyebrow: "Sharing",
      title: "Third-Party Disclosure",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">We will <strong>never sell, rent, or lease</strong> your personal information to any third party for their own marketing purposes.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Courier & Logistics Partners</strong> — your name, phone number, and delivery address are shared with our courier partners solely for the purpose of delivering your order.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Payment Gateways</strong> — your payment information is processed securely by our payment gateway partners. We do not receive or store your full card details.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Cloud & Technology Services</strong> — we use third-party platforms (including cloud storage and image hosting services) that may process data on our behalf. These providers are bound by their own data protection obligations.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Legal Obligations</strong> — we may disclose your information if required to do so by law or in response to a valid order from a government authority or court of competent jurisdiction.</p>
          </div>
        </div>
      ),
    },
    {
      num: "05",
      eyebrow: "Cookies",
      title: "Cookies & Tracking",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">Our website uses cookies — small text files placed on your device — to improve your browsing experience, remember your preferences, and analyze website traffic.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">Cookies do not give us access to your device or any information beyond what you choose to share with us. We use traffic log cookies solely for statistical analysis to improve our website.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">You can choose to accept or decline cookies via your browser settings. Declining cookies may limit some functionality of our website.</p>
          </div>
        </div>
      ),
    },
    {
      num: "06",
      eyebrow: "Storage",
      title: "Data Retention",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">We retain your personal data only for as long as necessary to fulfil the purposes for which it was collected — including order fulfilment, legal compliance, and dispute resolution.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">Order data is typically retained for a minimum of <strong>3 years</strong> for accounting and legal compliance purposes under applicable Indian law.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">Upon receipt of a valid deletion request (see Your Rights below), we will erase your personal data within a reasonable timeframe, except where retention is required by law.</p>
          </div>
        </div>
      ),
    },
    {
  num: "07",
  eyebrow: "Security",
  title: "Data Security",
  content: (
    <div className="pp-items">
      <div className="pp-item">
        <span className="pp-dash">—</span>
        <p className="pp-text">
          veshheon.in is independently assessed and scores in the top tier of web security standards. Our infrastructure enforces HTTPS-only access, strict transport security, cross-origin resource protection, and content security policies across all pages.
        </p>
      </div>
      <div className="pp-item">
        <span className="pp-dash">—</span>
        <p className="pp-text">
          We do not use tracking cookies, and our referrer policy is configured to share minimal information with external services. These are deliberate choices — not defaults.
        </p>
      </div>
      <div className="pp-item">
        <span className="pp-dash">—</span>
        <p className="pp-text">
          All data transmitted between your browser and our website is encrypted using SSL/TLS. While we maintain robust security practices, no system can guarantee absolute security against all threats.
        </p>
      </div>
    </div>
  ),
},
    {
      num: "08",
      eyebrow: "Cross-Border",
      title: "International Data Transfer",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">Some of our third-party service providers (including cloud storage and image hosting platforms) may store or process data on servers located outside India.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">By using our website and services, you acknowledge and consent to the transfer of your data to such providers for the limited purposes described in this policy. We ensure that such providers maintain adequate data protection standards.</p>
          </div>
        </div>
      ),
    },
    {
      num: "09",
      eyebrow: "Control",
      title: "Your Rights",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Right to Access</strong> — you may request a copy of the personal data we hold about you at any time.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Right to Correction</strong> — if any information we hold is inaccurate or incomplete, you may request that we correct it promptly.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Right to Deletion</strong> — you may request erasure of your personal data, subject to any legal obligations that require us to retain certain records.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Right to Withdraw Consent</strong> — you may opt out of marketing communications at any time by contacting us or using the unsubscribe link in any marketing email.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">To exercise any of the above rights, please contact us at <strong>support@veshheon.in</strong>. We will respond within <strong>30 days</strong> of receiving your request.</p>
          </div>
        </div>
      ),
    },
    {
      num: "10",
      eyebrow: "Compliance",
      title: "Grievance Officer",
      content: (
        <div className="pp-items">
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">In accordance with the Information Technology Act, 2000 and the IT (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, we have designated a Grievance Officer to address any concerns or complaints regarding the handling of your personal data.</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Grievance Officer:</strong> VESHH-EON Customer Support</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Contact:</strong> support@veshheon.in</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text"><strong>Location:</strong> Belagavi, Karnataka, India</p>
          </div>
          <div className="pp-item">
            <span className="pp-dash">—</span>
            <p className="pp-text">All grievances will be acknowledged within <strong>48 hours</strong> and resolved within <strong>30 days</strong> of receipt.</p>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <style>{ppStyles}</style>

      <div className="pp-root">

        {/* ── HEADER ── */}
        <div className="pp-header">
          <div>
            <span className="pp-eyebrow">Last Updated · November 2025</span>
            <h1 className="pp-title">Privacy <span className="pp-title-bold">Policy</span></h1>
          </div>
        </div>

        <div className="pp-rule-wrap"><hr className="pp-hr" /></div>

        {/* ── STATS ── */}
        <div className="pp-stats">
          <div className="pp-stat">
            <span className="pp-stat-num">0</span>
            <span className="pp-stat-label">Data Sold</span>
            <span className="pp-stat-sub">We never sell your data</span>
          </div>
          <div className="pp-stat-divider" />
          <div className="pp-stat">
            <span className="pp-stat-num">48h</span>
            <span className="pp-stat-label">Grievance Response</span>
            <span className="pp-stat-sub">Acknowledged within</span>
          </div>
          <div className="pp-stat-divider" />
          <div className="pp-stat">
            <span className="pp-stat-num">30d</span>
            <span className="pp-stat-label">Request Resolution</span>
            <span className="pp-stat-sub">Data rights requests</span>
          </div>
        </div>

        <div className="pp-rule-wrap"><hr className="pp-hr" /></div>

        {/* ── INTRO PULL ── */}
        <div className="pp-intro-wrap">
          <p className="pp-pull">
            "Your privacy matters to us. We collect only what we need, use it only as described, and never sell it to anyone."
          </p>
        </div>

        <div className="pp-rule-wrap"><hr className="pp-hr" /></div>

        {/* ── SECTIONS ── */}
        <div className="pp-sections">
          {sections.map((s, i) => {
            const words = s.title.split(" ");
            const light = words.slice(0, -1).join(" ");
            const bold = words[words.length - 1];
            return (
              <React.Fragment key={s.num}>
                <section className="pp-section">
                  <div className="pp-section-meta">
                    <span className="pp-section-num">{s.num}</span>
                    <div>
                      <span className="pp-section-eyebrow">{s.eyebrow}</span>
                      <h2 className="pp-section-title">
                        {light && <span className="pp-section-light">{light} </span>}
                        <span className="pp-section-bold">{bold}</span>
                      </h2>
                    </div>
                  </div>
                  <div className="pp-section-body">{s.content}</div>
                </section>
                {i < sections.length - 1 && (
                  <div className="pp-rule-wrap"><hr className="pp-hr" /></div>
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* ── CONTACT STRIP ── */}
        <div className="pp-rule-wrap"><hr className="pp-hr" /></div>
        <div className="pp-contact">
          <div className="pp-contact-left">
            <span className="pp-contact-eyebrow">Privacy Questions?</span>
            <span className="pp-contact-title">Contact Our Team</span>
          </div>
          <a href="mailto:support@veshheon.in" className="pp-contact-email">
            <span>support@veshheon.in</span>
            <span className="pp-contact-note">Response within 48 hours</span>
          </a>
        </div>

        <div className="pp-rule-wrap"><hr className="pp-hr" /></div>
        <div className="pp-closing">
          <span className="pp-closing-text">VESHH-EON · Privacy Policy · Belagavi, Karnataka, Bharat · November 2025</span>
        </div>

      </div>
    </>
  );
}

const ppStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,200;0,300;0,400;0,500;0,600;1,300&display=swap');

  .pp-root {
    background: #f8f8f8;
    min-height: 100vh;
    font-family: 'Exo 2', sans-serif;
    padding-bottom: 80px;
  }

  .pp-header {
    max-width: 1200px;
    margin: 0 auto;
    padding: 64px 80px 40px;
  }

  .pp-eyebrow {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.5em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 12px;
  }
  .pp-eyebrow::before {
    content: '';
    width: 24px;
    height: 1px;
    background: black;
    display: block;
    flex-shrink: 0;
  }

  .pp-title {
    font-size: clamp(32px, 4.5vw, 60px);
    font-weight: 200;
    color: #000;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
  }
  .pp-title-bold { font-weight: 600; }

  .pp-rule-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }
  .pp-hr {
    border: none;
    border-top: 1px solid black;
    margin: 0;
  }

  /* ── STATS ── */
  .pp-stats {
    max-width: 1200px;
    margin: 0 auto;
    padding: 52px 80px;
    display: flex;
    align-items: center;
  }

  .pp-stat {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0 40px;
  }
  .pp-stat:first-child { padding-left: 0; }
  .pp-stat:last-child  { padding-right: 0; }

  .pp-stat-num {
    font-size: clamp(36px, 4vw, 56px);
    font-weight: 200;
    color: #000;
    letter-spacing: -0.02em;
    line-height: 1;
  }

  .pp-stat-label {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    color: #000;
  }

  .pp-stat-sub {
    font-size: 9px;
    font-weight: 300;
    letter-spacing: 0.2em;
    color: black;
    text-transform: uppercase;
  }

  .pp-stat-divider {
    width: 1px;
    height: 60px;
    background: black;
    flex-shrink: 0;
  }

  /* ── INTRO ── */
  .pp-intro-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 80px;
  }

  .pp-pull {
    font-size: clamp(13px, 1.6vw, 17px);
    font-weight: 300;
    font-style: italic;
    color: black;
    line-height: 1.8;
    border-left: 2px solid black;
    padding-left: 20px;
    margin: 0;
    max-width: 680px;
    letter-spacing: 0.02em;
  }

  /* ── SECTIONS ── */
  .pp-sections {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 80px;
  }

  .pp-section {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 60px;
    padding: 52px 0;
  }

  .pp-section-meta {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .pp-section-num {
    font-size: 64px;
    font-weight: 200;
    color: black;
    line-height: 1;
    letter-spacing: -0.02em;
    display: block;
  }

  .pp-section-eyebrow {
    display: block;
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
    margin-bottom: 8px;
  }

  .pp-section-title {
    font-size: clamp(16px, 2vw, 28px);
    line-height: 1.1;
    margin: 0;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .pp-section-light { font-weight: 200; color: #000; }
  .pp-section-bold  { font-weight: 600; color: #000; }

  .pp-section-body { padding-top: 6px; }

  .pp-text {
    font-size: 13px;
    font-weight: 300;
    color: black;
    line-height: 2;
    letter-spacing: 0.04em;
    text-align: justify;
    margin: 0;
  }

  .pp-items { display: flex; flex-direction: column; gap: 14px; }
  .pp-item  { display: flex; align-items: flex-start; gap: 14px; }

  .pp-dash {
    font-size: 13px;
    font-weight: 300;
    color: black;
    flex-shrink: 0;
    padding-top: 2px;
  }

  /* ── CONTACT ── */
  .pp-contact {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }

  .pp-contact-left {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .pp-contact-eyebrow {
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.45em;
    text-transform: uppercase;
    color: black;
  }

  .pp-contact-title {
    font-size: clamp(18px, 2.5vw, 28px);
    font-weight: 200;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #000;
  }

  .pp-contact-email {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    text-decoration: none;
  }

  .pp-contact-email > span:first-child {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.08em;
    color: #000;
    position: relative;
    padding-bottom: 3px;
  }
  .pp-contact-email > span:first-child::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0;
    width: 100%;
    height: 1px;
    background: black;
    transition: background 0.25s ease;
  }
  .pp-contact-email:hover > span:first-child::after { background: #000; }

  .pp-contact-note {
    font-size: 8px;
    font-weight: 300;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: black;
  }

  /* ── CLOSING ── */
  .pp-closing {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px 80px 0;
    text-align: center;
  }

  .pp-closing-text {
    font-size: 8px;
    font-weight: 300;
    letter-spacing: 0.35em;
    text-transform: uppercase;
    color: black;
  }

  /* ── RESPONSIVE ── */
  @media (max-width: 1024px) {
    .pp-header     { padding: 48px 40px 32px; }
    .pp-rule-wrap  { padding: 0 40px; }
    .pp-stats      { padding: 40px 40px; }
    .pp-stat       { padding: 0 24px; }
    .pp-intro-wrap { padding: 40px 40px; }
    .pp-sections   { padding: 0 40px; }
    .pp-contact    { padding: 40px 40px; }
    .pp-closing    { padding: 20px 40px 0; }
    .pp-section    { grid-template-columns: 200px 1fr; gap: 40px; }
  }

  @media (max-width: 768px) {
    .pp-header     { padding: 40px 20px 28px; }
    .pp-rule-wrap  { padding: 0 20px; }
    .pp-stats      { padding: 36px 20px; flex-direction: column; align-items: flex-start; gap: 28px; }
    .pp-stat       { padding: 0; }
    .pp-stat-divider { width: 40px; height: 1px; }
    .pp-intro-wrap { padding: 36px 20px; }
    .pp-sections   { padding: 0 20px; }
    .pp-contact    { flex-direction: column; align-items: flex-start; padding: 36px 20px; gap: 20px; }
    .pp-contact-email { align-items: flex-start; }
    .pp-closing    { padding: 20px 20px 0; }
    .pp-section    { grid-template-columns: 1fr; gap: 20px; padding: 40px 0; }
    .pp-section-meta { flex-direction: row; align-items: flex-end; gap: 14px; }
    .pp-section-num  { font-size: 44px; }
  }

  @media (max-width: 360px) {
    .pp-header     { padding: 32px 14px 24px; }
    .pp-rule-wrap  { padding: 0 14px; }
    .pp-stats      { padding: 28px 14px; }
    .pp-intro-wrap { padding: 28px 14px; }
    .pp-sections   { padding: 0 14px; }
    .pp-contact    { padding: 28px 14px; }
    .pp-closing    { padding: 16px 14px 0; }
  }
`;
